<div class="page-container">
  <div
    class="page-content"
    [style.height.px]="
      (windowSize.contentHeight ?? 0) - gridConfigTabs.offsetHeight
    "
    >
    <div
      class="sia-grid-config-tab-container"
      id="backGridTabs"
      role="tablist"
      #gridConfigTabs
      >
      @if (isAdmin) {
        <div
          [ngClass]="currentTab == 'setup' ? 'active' : ''"
          id="setup"
          (click)="onNavItemClick('setup')"
          appI18n
          >
          Configurazioni
        </div>
      }
      @if (confVisible) {
        <div
          [ngClass]="currentTab == 'impostazioni-base' ? 'active' : ''"
          id="impostazioni-base"
          (click)="onNavItemClick('impostazioni-base')"
          appI18n
          >
          Base
        </div>
      }
      @if (isAdmin && confVisible) {
        <div
          [ngClass]="currentTab == 'impostazioni-avanzate' ? 'active' : ''"
          id="impostazioni-avanzate"
          (click)="onNavItemClick('impostazioni-avanzate')"
          appI18n
          >
          Avanzate
        </div>
      }
      @if (isAdmin && confVisible && isDesktop()) {
        <div
          [ngClass]="currentTab == 'adattivita-colonne' ? 'active' : ''"
          id="adattivita-colonne"
          (click)="onNavItemClick('adattivita-colonne')"
          appI18n
          >
          Adattività Colonne
        </div>
      }
      @if (isAdmin && confVisible && isDesktop()) {
        <div
          [ngClass]="currentTab == 'colonne-1' ? 'active' : ''"
          id="colonne-1"
          (click)="onNavItemClick('colonne-1')"
          appI18n
          >
          Colonne-1
        </div>
      }
      @if (isAdmin && confVisible && isDesktop()) {
        <div
          [ngClass]="currentTab == 'colonne-2' ? 'active' : ''"
          id="colonne-2"
          (click)="onNavItemClick('colonne-2')"
          appI18n
          >
          Colonne-2
        </div>
      }
      @if (isAdmin && confVisible && isDesktop()) {
        <div
          [ngClass]="currentTab == 'colonne-3' ? 'active' : ''"
          id="colonne-3"
          (click)="onNavItemClick('colonne-3')"
          appI18n
          >
          Colonne-3
        </div>
      }
      @if (isAdmin && confVisible && isDesktop()) {
        <div
          [ngClass]="currentTab == 'colonne-actions' ? 'active' : ''"
          id="colonne-actions"
          (click)="onNavItemClick('colonne-actions')"
          appI18n
          >
          Azioni
        </div>
      }
      @if (isAdmin && confVisible && isDesktop()) {
        <div
          [ngClass]="currentTab == 'colonne-val' ? 'active' : ''"
          id="colonne-val"
          (click)="onNavItemClick('colonne-val')"
          appI18n
          >
          Validazione
        </div>
      }
      @if (isAdmin && confVisible && isDesktop()) {
        <div
          [ngClass]="currentTab == 'editing' ? 'active' : ''"
          id="editing"
          (click)="onNavItemClick('editing')"
          appI18n
          >
          Editing
        </div>
      }
      @if (isAdmin && confVisible && isDesktop()) {
        <div
          [ngClass]="currentTab == 'stile' ? 'active' : ''"
          id="style"
          (click)="onNavItemClick('stile')"
          appI18n
          >
          Stile
        </div>
      }
      @if (isAdmin && confVisible && isDesktop()) {
        <div
          [ngClass]="currentTab == 'filtri' ? 'active' : ''"
          id="filtri"
          (click)="onNavItemClick('filtri')"
          appI18n
          >
          Pre-Filtri
        </div>
      }
      @if (isAdmin && confVisible && isDesktop() && gridConf?.useSp) {
        <div
          [ngClass]="currentTab == 'sp' ? 'active' : ''"
          id="sp"
          (click)="onNavItemClick('sp')"
          appI18n
          >
          Parametri SP
        </div>
      }
      @if (isAdmin && confVisible) {
        <div (click)="updateRemoteConf()">
          {{ "Salva" | siaTranslate }}
          <span class="fas fa-save fa-lg"></span>
        </div>
      }
    </div>
    @if (gridConf) {
      <div class="sia-conf-content" id="myTabContent">
        <!-- IMPOSTAZIONI AMMINISTRATIVE -->
        @if (currentTab == 'setup') {
          <div
            class="sia-conf-content"
            id="setup-tab"
            >
            <sia-grid-config-setup
              [gridConf]="gridConf"
              (perspectiveSelected)="onPerspectiveSelected($event)"
              (viewConfiguration)="onViewConfiguration()"
              (cloneConfiguration)="onCloneConfiguration($event)"
            ></sia-grid-config-setup>
          </div>
        }
        <!-- IMPOSTAZIONI BASE -->
        @if (currentTab == 'impostazioni-base') {
          <div
            class="sia-conf-content"
            id="impostazioni-base-tab"
            >
            <sia-grid-config-base [gridConf]="gridConf"> </sia-grid-config-base>
          </div>
        }
        <!-- IMPOSTAZIONI AVANZATE -->
        @if (currentTab == 'impostazioni-avanzate') {
          <div
            class="sia-conf-content"
            id="impostazioni-avanzate-tab"
            >
            <sia-grid-config-advanced
              [gridConf]="gridConf"
            ></sia-grid-config-advanced>
          </div>
        }
        <!-- ADATTIVITA' COLONNE -->
        @if (currentTab == 'adattivita-colonne') {
          <div
            class="sia-conf-content"
            id="adattivita-colonne"
            >
            <sia-grid-config-adaptability
              [gridConf]="gridConf"
            ></sia-grid-config-adaptability>
          </div>
        }
        <!-- COLONNE-1 -->
        @if (currentTab == 'colonne-1') {
          <div
            class="sia-conf-content"
            id="colonne-1-tab"
            >
            <sia-grid-config-cols-part-one
              [gridConf]="gridConf"
              [tabsHeight]="gridConfigTabs.offsetHeight"
              (refreshConf)="refreshCurrentConfiguration($event)"
            ></sia-grid-config-cols-part-one>
          </div>
        }
        <!-- COLONNE-2 -->
        @if (currentTab == 'colonne-2') {
          <div
            class="sia-conf-content"
            id="colonne-2-tab"
            >
            <sia-grid-config-cols-part-two
              [gridConf]="gridConf"
              [tabsHeight]="gridConfigTabs.offsetHeight"
            ></sia-grid-config-cols-part-two>
          </div>
        }
        <!-- COLONNE 3 -->
        @if (currentTab == 'colonne-3') {
          <div
            class="sia-conf-content"
            id="colonne-3-tab"
            >
            <sia-grid-config-cols-part-three
              [gridConf]="gridConf"
              [tabsHeight]="gridConfigTabs.offsetHeight"
            ></sia-grid-config-cols-part-three>
          </div>
        }
        <!-- ACTIONS -->
        @if (currentTab == 'colonne-actions') {
          <div
            class="sia-conf-content"
            id="colonne-actions-tab"
            >
            <sia-grid-config-actions
              [gridConf]="gridConf"
              [tabsHeight]="gridConfigTabs.offsetHeight"
            ></sia-grid-config-actions>
          </div>
        }
        <!-- COLONNE VALIDAZIONE -->
        @if (currentTab == 'colonne-val') {
          <div
            class="sia-conf-content"
            id="colonne-val-tab"
            >
            <sia-grid-config-validation
              [gridConf]="gridConf"
              [tabsHeight]="gridConfigTabs.offsetHeight"
            ></sia-grid-config-validation>
          </div>
        }
        <!-- MASCHERA DI Editing -->
        @if (currentTab == 'editing') {
          <div
            class="sia-conf-content"
            id="editing-tab"
            >
            <sia-grid-config-detail [gridConf]="gridConf"></sia-grid-config-detail>
          </div>
        }
        <!-- FILTRI GRIGLIA -->
        @if (currentTab == 'filtri') {
          <div class="sia-conf-content" id="filtri">
            <sia-grid-config-filters
              [gridConf]="gridConf"
              [tempCols]="tempCols"
              [tabsHeight]="gridConfigTabs.offsetHeight"
              >
            </sia-grid-config-filters>
          </div>
        }
        <!-- Patametri SP -->
        @if (currentTab == 'sp') {
          <div class="sia-conf-content" id="sp">
            <sia-grid-config-sp-parameters
              [gridConf]="gridConf"
              [tempCols]="tempCols"
              >
            </sia-grid-config-sp-parameters>
          </div>
        }
        <!-- STILI GRIGLIA -->
        @if (currentTab == 'stile') {
          <div class="sia-conf-content" id="style">
            <sia-grid-config-style
              [gridConf]="gridConf"
              [tempCols]="tempCols"
              [tabsHeight]="gridConfigTabs.offsetHeight"
              >
            </sia-grid-config-style>
          </div>
        }
      </div>
    }
  </div>
</div>
